import React from "react";
import { RiseUserActionStudentStatusEnum } from "@/__generated__/types";
import {
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
} from "@/components/ui";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/Spinner";

export const BulkStatusUpdateDropdown = ({
  onSelect,
  loading,
}: {
  onSelect: (status: RiseUserActionStudentStatusEnum) => void;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Select value="" onValueChange={onSelect}>
      <SelectTrigger
        className={cn("shadow-none data-[placeholder]:text-primary")}
      >
        {loading ? <Spinner /> : t(`riseActionDetails.actions`)}
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={RiseUserActionStudentStatusEnum.Done}>
          {t(
            `riseActionDetails.bulkActions.${RiseUserActionStudentStatusEnum.Done}`,
          )}
        </SelectItem>
        <SelectItem value={RiseUserActionStudentStatusEnum.NotDone}>
          {t(
            `riseActionDetails.bulkActions.${RiseUserActionStudentStatusEnum.NotDone}`,
          )}
        </SelectItem>
        <SelectItem value={RiseUserActionStudentStatusEnum.Skipped}>
          {t(
            `riseActionDetails.bulkActions.${RiseUserActionStudentStatusEnum.Skipped}`,
          )}
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
